import {ITrainingRecord} from '../message-models/training-record.interface';
import {IDateTimeWithZone} from '../common/date-time-with-zone.interface';
import {ITrainingType} from '../message-models/training-record-type.interface';
import {DateTimeWithZone} from '../common/date-time-with-zone.class';
import {TrainingRecordObservation} from './training-record-observation.class';
import {Observation} from './observation.class';
import {consts} from "../common/modals/consts";
import { DecimalPipe } from '@angular/common';

export class TrainingRecord implements ITrainingRecord{
  id: string;
  achievedOn: DateTimeWithZone;
  validTo: DateTimeWithZone;
  trainingType?: ITrainingType;
  trainingTypeId : string;
  trainingExtraDescription: string;
  operativeId: string;

  cpdHour: number;

  // trainingRecordObservations: Array<TrainingRecordObservation> = new Array<TrainingRecordObservation>();
  observations?: Array<Observation> = new Array<Observation>();
  trainingTypeName?: string;
  constructor(iTrainingRecord: ITrainingRecord = null) {
    this.id = iTrainingRecord?.id || consts.emptyGuid;
    this.trainingTypeId = iTrainingRecord?.trainingTypeId || consts.emptyGuid;
    this.operativeId = iTrainingRecord?.operativeId || consts.emptyGuid;
    this.achievedOn = new DateTimeWithZone(iTrainingRecord?.achievedOn);
    this.trainingType = iTrainingRecord?.trainingType || null;
    this.trainingExtraDescription = iTrainingRecord?.trainingExtraDescription || '';
    this.validTo =  new DateTimeWithZone(iTrainingRecord?.validTo);
    this.cpdHour = iTrainingRecord?.cpdHour || 0;
  }

  get isValid(): boolean {
    return !!this.achievedOn?.dateTime && this.trainingTypeSet && this.cpdHourCheck;
  }

  get trainingTypeSet(): boolean {
    return !!this.trainingTypeId && this.trainingTypeId !== consts.emptyGuid;
  }

  get cpdHourCheck(): boolean {
    return this.cpdHour >= 0;
  }

}
